import axios from "axios";
import { getUserInfo, clearUserInfo } from "@/utils/auth.js";
import router from "@/router";
// 进度条
import NProgress from "nprogress";
import { getApiBaseUrl } from "@/utils/baseUrl.js";
axios.defaults.baseURL = getApiBaseUrl();
import { getToken } from "./util.js";

axios.interceptors.request.use(function (req) {
  req.headers["token"] = getToken();
  if (req.url != "/web/userCourse/orderStatus") {
    // 启动进度条
    NProgress.start();
  }

  return req;
});

axios.interceptors.response.use(function (res) {
  // 结束进度条
  NProgress.done();
  return res;
});

async function request(option) {
  if (!option) {
    throw new Error("请求参数不能空");
  }
  if (!option.method) {
    option.method = "get";
  }
  if (option.method === "get" || option.method === "put") {
    option.params = option.data;
  }
  try {
    let { data: res } = await axios(option);
    console.log(res);
    if (res.code == 401) {
      clearUserInfo();
      router.push("/");
    }
    return res;
  } catch (error) {
    return error.message;
  }
}

export default request;
